export class HotjarHandler {
  constructor() {
    this.initialized = false;
    this._loadHotjarScript();
  }

  _loadHotjarScript() {
    if (!window.hj) {
      // Initialize Hotjar
      window.hj = window.hj || function() { (window.hj.q = window.hj.q || []).push(arguments) };
      window._hjSettings = {
        hjid: process.env.REACT_APP_HOTJAR_ID,
        hjsv: 6
      };

      // Load the script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
      
      script.onload = () => {
        this.initialized = true;
        if (process.env.NODE_ENV !== 'production') {
          console.log('Hotjar initialized with ID:', process.env.REACT_APP_HOTJAR_ID);
        }
      };

      document.head.appendChild(script);
    }
  }

  trackPageView(canonicalPath) {
    if (window.hj && this.initialized) {
      // Hotjar automatically tracks page views in SPAs when the URL changes
      // But we can manually trigger it as well for certainty
      window.hj('stateChange', canonicalPath);
      
      if (process.env.NODE_ENV !== 'production') {
        console.log('Hotjar stateChange triggered for:', canonicalPath);
      }
    }
  }

  // Identify user when they log in
  identifyUser(userId, userAttributes = {}) {
    if (window.hj && this.initialized && userId) {
      window.hj('identify', userId, userAttributes);
      
      if (process.env.NODE_ENV !== 'production') {
        console.log('Hotjar user identified:', userId);
      }
    }
  }
} 